module.exports = __webpack_public_path__ + "img/phone.fce48c62.svg";